var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CreateNavBar',{attrs:{"title":_vm.navbar_title}}),_vm._v(" "),_c('router-view',{attrs:{"companyId":_vm.companyId,"isOrganizer":_vm.isOrganizer,"redirectToLogin":_vm.redirectToLogin,"updateIsOrganizer":_vm.updateIsOrganizer,"setDataIsOrganizer":_vm.setDataIsOrganizer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63999b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/business_profile/CreateBusinessProfile.vue
// module id = null
// module chunks = 